export default function ValuesSection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-8 md:px-16 lg:px-24" style={{ backgroundColor: '#F5F2EB' }} aria-labelledby="values-title">
      <div className="max-w-7xl mx-auto">
        <div className="mb-4">
          <p className="font-label text-xs uppercase tracking-[0.2em] text-foreground-500 leading-relaxed">
            What we<br />stand for
          </p>
        </div>

        <h2 id="values-title" className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground-950 leading-tight tracking-tight mb-16 md:mb-20">
          Engineering<br />Principles
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          <div className="bg-foreground-950 rounded-3xl p-8 md:p-10 flex flex-col justify-between min-h-[360px] relative overflow-hidden">
            <div className="w-10 h-10 rounded-full bg-accent-400/30 flex items-center justify-center">
              <div className="w-4 h-4 rounded-sm bg-background-50"></div>
            </div>
            <div>
              <p className="font-heading text-2xl md:text-3xl text-background-50 font-medium leading-tight mb-3">
                Scalable Architecture
              </p>
              <p className="text-sm text-background-400 leading-relaxed">
                Systems designed to grow with your ambitions, built on modular foundations that evolve gracefully over time.
              </p>
            </div>
          </div>

          <div className="rounded-3xl min-h-[360px] relative overflow-hidden flex flex-col justify-end p-8 md:p-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20monochromatic%20textured%20surface%20in%20warm%20charcoal%20and%20soft%20beige%20tones%2C%20geometric%20subtle%20pattern%20with%20organic%20texture%20overlay%2C%20no%20objects%20no%20people%2C%20minimalist%20fine%20art%20composition%2C%20delicate%20grain%20texture%2C%20soft%20tonal%20variations%2C%20architectural%20abstract%20quality&width=800&height=1000&seq=values-card-bruny-02&orientation=portrait"
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
            <div className="absolute top-6 left-6">
              <div className="bg-background-50/20 backdrop-blur-sm rounded-full px-4 py-1.5">
                <span className="text-xs text-background-50 font-medium tracking-wide">Core Value</span>
              </div>
            </div>
            <div className="relative z-10">
              <p className="font-heading text-2xl md:text-3xl text-background-50 font-medium leading-tight mb-3">
                Technical Quality
              </p>
              <p className="text-sm text-background-200 leading-relaxed">
                Uncompromising standards in code quality, testing, and documentation ensure long-term maintainability.
              </p>
            </div>
          </div>

          <div className="rounded-3xl p-8 md:p-10 flex flex-col justify-between min-h-[360px]" style={{ backgroundColor: '#F5F2EB' }}>
            <div>
              <p className="font-heading text-2xl md:text-3xl text-foreground-950 font-medium leading-tight mb-3">
                User-Centered Design
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Every technical decision is informed by the people who will interact with the software, ensuring intuitive and meaningful experiences.
              </p>
            </div>
            <div className="mt-8">
              <div className="flex items-end gap-1">
                <div className="h-1 flex-1 rounded-full bg-accent-400/60"></div>
                <div className="h-4 w-1 rounded-full bg-accent-500"></div>
                <div className="h-8 w-1 rounded-full bg-accent-600"></div>
                <div className="h-12 w-1 rounded-full bg-accent-700"></div>
                <div className="h-6 w-1 rounded-full bg-accent-500"></div>
                <div className="h-3 w-1 rounded-full bg-accent-400/60"></div>
                <div className="h-1 flex-1 rounded-full bg-accent-300/40"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}